import React from 'react';
import {Map, GoogleApiWrapper} from 'google-maps-react';
import {centerOfTexas} from 'utility/constants';

const GoogleMap = ({
  google,
  onReady=() => console.log("Ready!"),
  initialCenter= centerOfTexas,
  containerStyle={
    position: 'absolute', top: '0vh', right: 0, left: 0, width: '100%', height: '100%',
  },
  style={width: '100%', height: '100%', opacity: .4 },
  zoom=7,
  children,
  ...props
}) => {
  return <Map 
    onReady={(mapProps, map) => {
      onReady(mapProps, map, google)
    }}
    initialCenter={initialCenter}
    google={google}
    fullscreenControl={false}
    zoomControl={false}
    scaleControl={false}
    streetViewControl={false}
    panControl={false}
    draggable={false}
    disableDoubleClickZoom={false}
    keyboardShortcuts={false}
    mapTypeControl={false}
    containerStyle = {containerStyle}
    style={style} 
    zoom={zoom}
    {...props}
    >
    {children}
  </Map>
}

export default GoogleApiWrapper({
  apiKey: ('AIzaSyC4naCkz07mC-gzOSLlktir6SL0OhCWyxc')
})(GoogleMap)